function App({session}) {


  return (
    <header>
          <nav className={session !== false ? "navbar navbarVariant2 py-0" : "navbar py-0"}>
            <div className="container-fluid px-5 py-2" style={{ backdropFilter: "brightness(0.6)", }}>
                <a className="navbar-brand brandCol" href="/">
                    <img src="/images/mmk.svg" alt="" width="130" height="auto" />
                </a>
                <h3 className="textCol githubClass d-none d-lg-block">Reservación de Salas de MMKG</h3>
            </div>
        </nav>
    </header>
  );
}

export default App;

